/** Display formatting helpers. */

export function formatClock(tsSeconds: number): string {
  const date = new Date(tsSeconds * 1000);
  return date.toLocaleString('zh-CN', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelative(tsSeconds: number, now = Date.now() / 1000): string {
  const diff = Math.round(tsSeconds - now);
  const abs = Math.abs(diff);
  const suffix = diff <= 0 ? '前' : '后';
  if (abs < 60) return diff <= 0 ? '刚刚' : '即将';
  if (abs < 3600) return `${Math.round(abs / 60)} 分钟${suffix}`;
  if (abs < 86_400) return `${Math.round(abs / 3600)} 小时${suffix}`;
  return `${Math.round(abs / 86_400)} 天${suffix}`;
}

export function formatCountdown(expiresAt: number, now = Math.floor(Date.now() / 1000)): string {
  const remaining = expiresAt - now;
  if (remaining <= 0) return '已过期';
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  if (hours >= 1) return `${hours} 小时 ${minutes} 分钟`;
  if (minutes >= 1) return `${minutes} 分钟`;
  return '不到 1 分钟';
}

export function formatTokens(tokens: number | undefined): string {
  if (tokens === undefined) return '—';
  if (tokens >= 1_000_000) return `${(tokens / 1_000_000).toFixed(2)}M`;
  if (tokens >= 1000) return `${(tokens / 1000).toFixed(1)}k`;
  return String(tokens);
}

export function formatCost(cny: number | undefined): string {
  if (cny === undefined) return '—';
  if (cny < 0.01) return '¥<0.01';
  return `¥${cny.toFixed(2)}`;
}

export function formatDuration(ms: number): string {
  if (ms < 1000) return `${Math.round(ms)}ms`;
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.round(ms / 60_000)}min`;
}

/** Session duration for review cards/detail (e.g. `42s`, `3m 20s`, `2h 5m`, `3d 4h`). */
export function formatDurationSeconds(seconds: number): string {
  const total = Math.max(0, Math.round(seconds));
  if (total < 60) return `${total}s`;
  const minutes = Math.floor(total / 60);
  const secs = total % 60;
  if (minutes < 60) return secs > 0 ? `${minutes}m ${secs}s` : `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const restMinutes = minutes % 60;
  if (hours < 24) return restMinutes > 0 ? `${hours}h ${restMinutes}m` : `${hours}h`;
  const days = Math.floor(hours / 24);
  const restHours = hours % 24;
  return restHours > 0 ? `${days}d ${restHours}h` : `${days}d`;
}

export function shortId(id: string, length = 10): string {
  if (id.length <= length) return id;
  return `${id.slice(0, length)}…`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
}
